import {
  getBaseState,
  getEntityAdapterReducers,
  handleFulfilledAction,
  handleMultipleLoadingActions,
} from '@hwm/ui-lib/core/store';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { mapPreferencesAPIValuesToStore } from '@shared/components/Preferences';
import { PreferencesStoreModel } from '@shared/models';
import { thunks } from './PreferencesThunks';
import { EntityReducers } from '@core/store/EntityReducer';

const entityAdapter = createEntityAdapter<PreferencesStoreModel>({});

const slice = createSlice({
  name: EntityReducers.preferences,
  initialState: {
    ...getBaseState(entityAdapter),
  },
  reducers: {
    ...getEntityAdapterReducers(entityAdapter),
  },
  extraReducers: (builder) => {
    handleMultipleLoadingActions([thunks.getPreferences, thunks.savePreferences], builder);
    handleFulfilledAction(thunks.getPreferences, builder, (state, payload) => {
      entityAdapter.upsertOne(state, mapPreferencesAPIValuesToStore(payload));
    });
    handleFulfilledAction(thunks.savePreferences, builder, () => {});
  },
});

export const preferencesReducer = {
  slice,
  entityAdapter,
  thunks,
};
